export const SchemeParameterPaths = {
  BasicData: '/settings/scheme-parameter-basic-data',
  BasicSettings: '/settings/scheme-parameter-basic-settings',
  MailSettings: '/settings/scheme-parameter-mail-settings',
  EmailBody: '/settings/scheme-parameter-email-body',
};

export const BusinessPartnerPaths = ['/settings/business-partner'];
export const ExternalWarehousesPaths = ['/settings/external-warehouses'];
export const NonFoodPaths = {
  DispoWeeks: '/settings/non-food-dispo-weeks',
  Optimizing: '/settings/non-food-optimizing',
  NonFoodEmailBody: '/settings/non-food-email-body',
  NonFoodExternalWarehouses: '/settings/non-food-external-warehouses',
};

export enum BusinessPartnerType {
  Supplier = 1,
  Hauler = 2,
  Country = 3,
}

export const SupplierOfficeLocationTypeId = 1; //=Firmensitz

export enum SettingCategory {
  NonFoodParameter = 14,
}

export enum NfSettingDispoWeek {
  CREATION_TIME = 1,
}
